module.exports = __webpack_public_path__ + "views/basicData.ae7f7f2fc39066b3ae8a811624d24bcc.html";